/**
 * Ticker — bottom-of-page editorial ticker with bullet-separated items.
 * Optionally auto-scrolls horizontally ("marquee" style) for live feel.
 *
 * @example
 *   <Ticker items={["Now serving · Allure Image", "NJ", "12 studios onboarded"]} />
 *   <Ticker scroll items={items} tone="dark" />
 */
import React from "react";

const TONE = {
  light: {
    wrap: "border-y border-[color:var(--charcoal)]/15 bg-[color:var(--cream)] text-[color:var(--charcoal)]",
    dot:  "text-[color:var(--gold-base)]",
  },
  dark: {
    wrap: "border-y border-[color:var(--gold-foil)]/25 bg-[color:var(--charcoal)] text-[color:var(--cream)]",
    dot:  "text-[color:var(--gold-foil)]",
  },
};

export default function Ticker({ items = [], scroll = false, tone = "light", className = "", ...rest }) {
  const T = TONE[tone] || TONE.light;
  const row = (
    <span className="inline-flex items-center gap-6 px-2">
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <span className="ed-eyebrow whitespace-nowrap">{it}</span>
          {i < items.length - 1 || scroll ? (
            <span className={`text-[10px] leading-none ${T.dot}`} aria-hidden="true">●</span>
          ) : null}
        </React.Fragment>
      ))}
    </span>
  );
  return (
    <div className={`w-full ${T.wrap} ${className}`} {...rest}>
      <div className="py-3 overflow-hidden">
        {scroll ? (
          <div className="flex w-max animate-[ticker_30s_linear_infinite]">
            {row}
            {row}
          </div>
        ) : (
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
            {row}
          </div>
        )}
      </div>
      <style>{`@keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
